import React from 'react'
import AmbulatoryMedicationLayout from 'presentation/doctor/layouts/AmbulatoryMedication'

function AmbulatoryMedication() {
  return <AmbulatoryMedicationLayout />
}

export default AmbulatoryMedication
